const permissions = {
  Admin_UserSystem_View: "Admin.UserSystem.View",
  Admin_UserSystem_Create: "Admin.UserSystem.Create",
  Admin_UserSystem_Update: "Admin.UserSystem.Update",
  Admin_UserSystem_Delete: "Admin.UserSystem.Delete",
  Admin_UserSystem_ResetPassword: "Admin.UserSystem.ResetPassword",

  Admin_Role_View: "Admin.Role.View",
  Admin_Role_Create: "Admin.Role.Create",
  Admin_Role_Update: "Admin.Role.Update",
  Admin_Role_Delete: "Admin.Role.Delete",

  Admin_UserCustomer_View: "Admin.UserCustomer.View",
  Admin_UserCustomer_Create: "Admin.UserCustomer.Create",
  Admin_UserCustomer_Update: "Admin.UserCustomer.Update",
  Admin_UserCustomer_Delete: "Admin.UserCustomer.Delete",

  Admin_Product_View: "Admin.Product.View",
  Admin_Product_Create: "Admin.Product.Create",
  Admin_Product_Update: "Admin.Product.Update",
  Admin_Product_Delete: "Admin.Product.Delete",

  Admin_ProductCategory_View: "Admin.ProductCategory.View",
  Admin_ProductCategory_Create: "Admin.ProductCategory.Create",
  Admin_ProductCategory_Update: "Admin.ProductCategory.Update",
  Admin_ProductCategory_Delete: "Admin.ProductCategory.Delete",

  Admin_Blog_View: "Admin.Blog.View",
  Admin_Blog_Create: "Admin.Blog.Create",
  Admin_Blog_Update: "Admin.Blog.Update",
  Admin_Blog_Delete: "Admin.Blog.Delete",

  Admin_BlogCategory_View: "Admin.BlogCategory.View",
  Admin_BlogCategory_Create: "Admin.BlogCategory.Create",
  Admin_BlogCategory_Update: "Admin.BlogCategory.Update",
  Admin_BlogCategory_Delete: "Admin.BlogCategory.Delete",

  Admin_Voucher_View: "Admin.Voucher.View",
  Admin_Voucher_Create: "Admin.Voucher.Create",
  Admin_Voucher_Update: "Admin.Voucher.Update",
  Admin_Voucher_Delete: "Admin.Voucher.Delete",

  Admin_Promotion_View: "Admin.Promotion.View",
  Admin_Promotion_Create: "Admin.Promotion.Create",
  Admin_Promotion_Update: "Admin.Promotion.Update",
  Admin_Promotion_Delete: "Admin.Promotion.Delete",

  Admin_Setting_View: "Admin.Setting.View",
  Admin_Setting_Create: "Admin.Setting.Create",
  Admin_Setting_Update: "Admin.Setting.Update",
  Admin_Setting_Delete: "Admin.Setting.Delete",

  Admin_Report_View: "Admin.Report.View",
  Admin_Report_Create: "Admin.Report.Create",
  Admin_Report_Update: "Admin.Report.Update",
  Admin_Report_Delete: "Admin.Report.Delete",
  Admin_Report_Export: "Admin.Report.Export",

  Admin_Shipping_View: "Admin.Shipping.View",
  Admin_Shipping_Create: "Admin.Shipping.Create",
  Admin_Shipping_Update: "Admin.Shipping.Update",
  Admin_Shipping_Delete: "Admin.Shipping.Delete",

  Admin_Shipping_Note_Create: "Admin.Shipping.Note.Create",
  Admin_Shipping_Note_Delete: "Admin.Shipping.Note.Delete",


  Admin_Address_View: "Admin.Address.View",
  Admin_Address_Create: "Admin.Address.Create",
  Admin_Address_Update: "Admin.Address.Update",
  Admin_Address_Delete: "Admin.Address.Delete",

  Admin_Payment_View: "Admin.Payment.View",
  Admin_Payment_Create: "Admin.Payment.Create",
  Admin_Payment_Update: "Admin.Payment.Update",
  Admin_Payment_Delete: "Admin.Payment.Delete",

  Admin_Page_View: "Admin.Page.View",
  Admin_Page_Create: "Admin.Page.Create",
  Admin_Page_Update: "Admin.Page.Update",
  Admin_Page_Delete: "Admin.Page.Delete",

  Admin_Newspapers_View: "Admin.Newspapers.View",
  Admin_Newspapers_Create: "Admin.Newspapers.Create",
  Admin_Newspapers_Update: "Admin.Newspapers.Update",
  Admin_Newspapers_Delete: "Admin.Newspapers.Delete",

  Admin_Advertising_View: "Admin.Advertising.View",
  Admin_Advertising_Create: "Admin.Advertising.Create",
  Admin_Advertising_Update: "Admin.Advertising.Update",
  Admin_Advertising_Delete: "Admin.Advertising.Delete",


  Admin_Order_Get: "Admin.Order.Get",
  Admin_Order_View: "Admin.Order.View",
  Admin_Order_Create: "Admin.Order.Create",
  Admin_Order_Update: "Admin.Order.Update",
  Admin_Order_Delete: "Admin.Order.Delete",


  Admin_Review_View: "Admin.Review.View",
  Admin_Review_Create: "Admin.Review.Create",
  Admin_Review_Update: "Admin.Review.Update",
  Admin_Review_Delete: "Admin.Review.Delete",

  
  Admin_Menu_View: "Admin.Menu.View",
  Admin_Menu_Create: "Admin.Menu.Create",
  Admin_Menu_Update: "Admin.Menu.Update",
  Admin_Menu_Delete: "Admin.Menu.Delete",

  Admin_Agency_View: "Admin.Agency.View",
  Admin_Agency_Create: "Admin.Agency.Create",
  Admin_Agency_Update: "Admin.Agency.Update",
  Admin_Agency_Delete: "Admin.Agency.Delete",
  
  Admin_Transaction_View : "Admin.Transaction.View"
};

export default permissions;
